import React from 'react';
import feature1 from '../assets/feature-1.png';
import feature2 from '../assets/feature-2.png';
import feature3 from '../assets/feature-3.png';
import feature4 from '../assets/feature-4.png';

const Detail = () => {
  return (
    <section
      className='py-20 bg-primary text-white'
      id='feature'
    >
      <div className='container mx-auto px-4 max-w-6xl'>
        <div className='text-center mb-16'>
          <h2 className='text-3xl md:text-4xl font-bold text-white mb-4'>
            One Win at a Time.
          </h2>
          <p className='text-lg md:text-xl text-text-submain max-w-2xl mx-auto'>
            From Stuck to Strong — One Challenge at a Time.
          </p>
        </div>

        <div className='flex flex-col gap-8'>
          {/* Card 1: Choose your challenge */}
          <div className='bg-secondary rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row border border-tertiary'>
            <div className='md:w-1/2 p-6 md:p-8 flex flex-col justify-center'>
              <h3 className='text-2xl font-bold text-white mb-4'>
                Choose your challenge.
              </h3>
              <p className='text-gray-300 mb-6'>
                Browse through a variety of fitness challenges designed for all
                levels. From beginner-friendly workouts to advanced training
                programs, find the perfect challenge that matches your goals.
              </p>
            </div>
            <div className='md:w-1/2 bg-tertiary p-6 flex items-center justify-center'>
              <div className='relative w-48 h-96'>
                <img
                  src={feature1}
                  alt='Feature 1'
                  className='w-full h-full object-cover'
                />
              </div>
            </div>
          </div>

          {/* Card 2: Keep tracking your progress */}
          <div className='bg-secondary rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row-reverse border border-tertiary'>
            <div className='md:w-1/2 p-6 md:p-8 flex flex-col justify-center'>
              <h3 className='text-2xl font-bold text-white mb-4'>
                Keep tracking your progress
              </h3>
              <p className='text-gray-300 mb-6'>
                Monitor your fitness journey with detailed progress tracking.
                Log your workouts, track your measurements, and see your
                improvements over time with visual charts and statistics.
              </p>
            </div>
            <div className='md:w-1/2 bg-tertiary p-6 flex items-center justify-center'>
              <div className='relative w-48 h-96'>
                <img
                  src={feature2}
                  alt='Feature 2'
                  className='w-full h-full object-cover'
                />
              </div>
            </div>
          </div>

          {/* Card 3: AI Calculation will help your meal tracking */}
          <div className='bg-secondary rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row border border-tertiary'>
            <div className='md:w-1/2 p-6 md:p-8 flex flex-col justify-center'>
              <h3 className='text-2xl font-bold text-white mb-4'>
                AI Calculation will help your meal tracking
              </h3>
              <p className='text-gray-300 mb-6'>
                Simply take a photo of your meal, and our AI will calculate
                calories and nutrients automatically. No more manual tracking or
                guesswork. Make informed decisions about your nutrition with
                ease.
              </p>
            </div>
            <div className='md:w-1/2 bg-tertiary p-6 flex items-center justify-center'>
              <div className='relative w-48 h-96'>
                <img
                  src={feature3}
                  alt='Feature 3'
                  className='w-full h-full object-cover'
                />
              </div>
            </div>
          </div>

          {/* Card 4: Goal Setting */}
          <div className='bg-secondary rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row-reverse border border-tertiary'>
            <div className='md:w-1/2 p-6 md:p-8 flex flex-col justify-center'>
              <h3 className='text-2xl font-bold text-white mb-4'>
                Goal Setting
              </h3>
              <p className='text-gray-300 mb-6'>
                Set realistic fitness goals and track your progress toward
                achieving them. Break down big goals into smaller milestones and
                celebrate each achievement along the way.
              </p>
            </div>
            <div className='md:w-1/2 bg-tertiary p-6 flex items-center justify-center'>
              <div className='relative w-48 h-96'>
                <img
                  src={feature4}
                  alt='Feature 4'
                  className='w-full h-full object-cover'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Detail;
